import { render, staticRenderFns } from "./flashSaleCourseTermAdd.vue?vue&type=template&id=5611b2fb&scoped=true"
import script from "./flashSaleCourseTermAdd.vue?vue&type=script&lang=js"
export * from "./flashSaleCourseTermAdd.vue?vue&type=script&lang=js"
import style0 from "./flashSaleCourseTermAdd.vue?vue&type=style&index=0&id=5611b2fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5611b2fb",
  null
  
)

export default component.exports